import { render, staticRenderFns } from "./FinanceStatistics.vue?vue&type=template&id=66fa638f&scoped=true&"
import script from "./FinanceStatistics.vue?vue&type=script&lang=js&"
export * from "./FinanceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FinanceStatistics.vue?vue&type=style&index=0&id=66fa638f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa638f",
  null
  
)

export default component.exports